import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export const ERRORS_ADD_ERROR = 'errors/addError';

export interface ErrorsState {
  errors: Error[];
}

export const state: ErrorsState = {
  errors: [],
};

export const getters: GetterTree<ErrorsState, any> = {
  errors: () => state.errors,
};

export const mutations: MutationTree<ErrorsState> = {
  addError: (_, error) => state.errors.unshift(error)
};

const actions: ActionTree<ErrorsState, any> = {
  addError: ({ commit }, error) => {
    commit('addError', error);
  }
};

export const errors: Module<ErrorsState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
